import { SxProps, sliderClasses } from '@mui/material'

interface SliderStyles {
  slider: SxProps
}

export const sliderStyles: SliderStyles = {
  slider: {
    padding: 0,
    height: 56,
    color: 'brand.primary600',
    '@media (pointer: coarse)': {
      padding: { md: 0 },
    },
    [`.${sliderClasses.track}`]: {
      top: '30%',
      height: 8,
      border: 'none',
    },
    [`.${sliderClasses.rail}`]: {
      top: '30%',
      height: 8,
      opacity: 1,
      color: 'button.borderDisabled',
    },
    [`.${sliderClasses.thumb}`]: {
      top: '30%',
      width: 24,
      height: 24,
      backgroundColor: 'background.default',
      border: '2px solid',
      borderColor: 'brand.primary600',
      boxShadow: '0 4px 6px -1px rgba(10, 13, 18, 0.10), 0 2px 4px -2px rgba(10, 13, 18, 0.06)',
      transform: 'translate(0%, -50%)',
      '&:last-child': {
        transform: 'translate(-100%,-50%)',
      },
      [`&:focus, &:hover, &.${sliderClasses.active}`]: {
        boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
        '@media (hover: none)': {
          boxShadow:
            '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
        },
      },
      '&:before': {
        boxShadow:
          '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
      },
    },
    [`.${sliderClasses.valueLabel}`]: {
      top: 50,
      px: 0,
      backgroundColor: 'transparent',
      '&::before': {
        display: 'none',
      },
      '& *': {
        background: 'transparent',
        color: 'text.primary900',
        typography: 'textXsMedium',
      },
    },
  },
}
